@if (showNavbar) {
<!-- Left Sidebar -->
<aside class="fixed inset-y-0 left-0 w-64 bg-white border-r border-gray-200 flex flex-col z-40">
  <!-- Logo -->
  <div class="px-4 h-16 flex items-center border-b border-gray-100 flex-shrink-0">
    <div class="flex items-center gap-2.5 min-w-0">
      <div
        class="w-8 h-8 rounded-lg bg-blue-600 text-white flex items-center justify-center font-bold text-sm flex-shrink-0">
        S
      </div>
      <span class="text-base font-semibold text-gray-900 truncate">SEL <span
          class="text-gray-400 font-normal">Studio</span></span>
    </div>
  </div>

  <!-- Navigation -->
  <div class="flex-1 overflow-y-auto px-3 py-4">
    <p class="px-3 mb-2 text-[11px] font-semibold text-gray-400 uppercase tracking-wider">Workspace</p>
    <app-navbar></app-navbar>
    <app-sidebar-projects></app-sidebar-projects>
  </div>

  <!-- User footer -->
  <div class="border-t border-gray-100 p-2 flex-shrink-0">
    <app-menu></app-menu>
  </div>
</aside>
}

<main [class.ml-64]="showNavbar"
  class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/50">
  @if (showNavbar) {
  <!-- Global top bar -->
  <header
    class="sticky top-0 z-30 h-14 flex items-center gap-4 px-4 md:px-6 bg-white/80 backdrop-blur border-b border-gray-200">
    <!-- Global search -->
    <div class="flex-1 max-w-xl">
      <app-global-search class="block w-full"></app-global-search>
    </div>

    <!-- Right: date + notifications + new -->
    <div class="ml-auto flex items-center gap-3">
      <app-calendar-popover></app-calendar-popover>
      <app-notification-bell></app-notification-bell>

      <!-- New: create-anything shortcut -->
      <div class="relative">
        <button (click)="newMenuOpen = !newMenuOpen"
          class="inline-flex items-center gap-1.5 pl-3.5 pr-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          New
          <svg class="w-3.5 h-3.5 opacity-80 transition-transform" [class.rotate-180]="newMenuOpen" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        @if (newMenuOpen) {
        <div class="fixed inset-0 z-40" (click)="newMenuOpen = false"></div>
        <div class="absolute right-0 mt-2 w-52 bg-white rounded-xl shadow-lg border border-gray-200 py-1.5 z-50">
          <button (click)="createProject()"
            class="w-full flex items-center gap-3 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
            <span class="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 inline-flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
              </svg>
            </span>
            <span class="flex flex-col items-start leading-tight">
              <span class="font-medium">New project</span>
              <span class="text-xs text-gray-400">Start a new project</span>
            </span>
          </button>
          @if (hasTasksAccess) {
          <button (click)="createTask()"
            class="w-full flex items-center gap-3 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
            <span class="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 inline-flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
              </svg>
            </span>
            <span class="flex flex-col items-start leading-tight">
              <span class="font-medium">New task</span>
              <span class="text-xs text-gray-400">Add a to-do</span>
            </span>
          </button>
          }
        </div>
        }
      </div>
    </div>
  </header>
  }
  <div class="md:px-6 px-4 py-4">
    <router-outlet></router-outlet>
  </div>
</main>
<app-toast></app-toast>

@if (showNewTaskModal) {
<app-add-task-modal (close)="showNewTaskModal = false"></app-add-task-modal>
}
